import { formatMetricValue } from '../../../metrics/metrics-helpers';

export const getProdDetailsTabWithGtm = (title, hash, productName, gtmId) => ({
    title,
    hash,
    gtmCategory: 'prodDetailsTab',
    gtmValue: productName,
    gtmId: gtmId || (title && formatMetricValue(title))
})